import script from "./MainNavigationMobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainNavigationMobile.vue?vue&type=script&lang=ts&setup=true"

import "./MainNavigationMobile.vue?vue&type=style&index=0&id=318159dd&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-318159dd"]])

export default __exports__